export const parseCurrency = (currency: string) => {
  const currencyMap: { [key: string]: string } = {
    BRL: 'R$',
    EURO: '€',
    USD: '$',
  };

  return currencyMap[currency] || '$';
};
